import { scrollToTop } from '~/lib/gsap-core';

const doNotscrollToTopPages = [ 'gplay', 'gplay-id' ];

export default {
    scrollBehavior ( to, from, savedPosition ) {

        // 點擊事件來自 header/footer，滾動至頂
        const lastTrigger = document.activeElement?.dataset?.trigger;
        if ( lastTrigger === 'header' || lastTrigger === 'footer' || to.path === from.path ) {
            scrollToTop();
            return;
        }

        // 重新整理、指定頁面不會 scroll to top
        else if ( savedPosition || doNotscrollToTopPages.some( page => to.name.includes( page ) && from?.name?.includes( page ) ) ) {
            return savedPosition;
        }

        else {
            scrollToTop();
            return false;
        }

    }

};

